export interface TextSegment {
  text: string
  diff: boolean
}

/** Großbuchstaben, nur A-Z und 0-9 (wie im Backend-Matcher). */
export function normalizeNumber(value?: string): string {
  return (value ?? "").trim().toUpperCase().replace(/[^A-Z0-9]/g, "")
}

function merge(segments: TextSegment[]): TextSegment[] {
  const t_result: TextSegment[] = []
  for (const t_s of segments) {
    const t_last = t_result[t_result.length - 1]
    if (t_last && t_last.diff === t_s.diff) {
      t_last.text += t_s.text
    } else {
      t_result.push({...t_s})
    }
  }
  return t_result
}

/**
 * Markiert die Unterschiede zwischen erfasster und vorgeschlagener Nummer.
 * Gleiche Länge: Zeichen für Zeichen. Sonst: gemeinsamer Anfang und gemeinsames Ende bleiben unmarkiert.
 * Die erfasste Nummer wird so angezeigt, wie sie erfasst wurde (ohne Normalisierung der Anzeige),
 * die Markierung nutzt die normalisierte Form nur, wenn beide Schreibweisen gleich lang sind.
 */
export function diffSegments(recorded: string, suggested: string): { recorded: TextSegment[], suggested: TextSegment[] } {
  const t_a = recorded ?? ""
  const t_b = suggested ?? ""
  if (t_a.length === t_b.length) {
    return {
      recorded: merge([...t_a].map((c, i) => ({text: c, diff: c.toUpperCase() !== t_b[i].toUpperCase()}))),
      suggested: merge([...t_b].map((c, i) => ({text: c, diff: c.toUpperCase() !== t_a[i].toUpperCase()}))),
    }
  }

  let t_prefix = 0
  while (t_prefix < t_a.length && t_prefix < t_b.length && t_a[t_prefix].toUpperCase() === t_b[t_prefix].toUpperCase()) {
    t_prefix++
  }
  let t_suffix = 0
  while (
    t_suffix < t_a.length - t_prefix &&
    t_suffix < t_b.length - t_prefix &&
    t_a[t_a.length - 1 - t_suffix].toUpperCase() === t_b[t_b.length - 1 - t_suffix].toUpperCase()
    ) {
    t_suffix++
  }
  const t_split = (s: string): TextSegment[] => merge([
    {text: s.substring(0, t_prefix), diff: false},
    {text: s.substring(t_prefix, s.length - t_suffix), diff: true},
    {text: s.substring(s.length - t_suffix), diff: false},
  ].filter(t => t.text.length > 0))
  return {recorded: t_split(t_a), suggested: t_split(t_b)}
}
